export const WALLET_EXPERIMENT_KEY = "wallet-enablement-v1";
export const FLEXBENEFITS_EXPERIMENT_KEY = "flexbenefits-plan-v1";
// Separate from FLEXBENEFITS_EXPERIMENT_KEY (Slice 1, already shipped) so the Slice 4
// ID card/wallet placeholder can ship/rollback independently. Starts disabled in
// Amplitude -- flip only for QA testing of the placeholder, not for real members.
export const FLEXBENEFITS_IDCARD_EXPERIMENT_KEY = "flexbenefits-idcard-v1";

export const VARIANT_TREATMENT = "treatment";
export const VARIANT_CONTROL = "control";
